import { render, staticRenderFns } from "./IssueBoard.vue?vue&type=template&id=61eb90b9&"
import script from "./IssueBoard.vue?vue&type=script&lang=js&"
export * from "./IssueBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports